export const THIS_FIELD_IS_REQUIRED = "This field is required";
export const LOGIN_PAGE_URL = "/login";

export const passwordRegex = new RegExp(
	"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z.,@#!$%^&*()-_=+;'\"`\\d]{8,}$"
);

export const CRON_TIME = {
	"* * * * *": "Every 1 minute",
	"0 * * * *": "Every 1 hour",
	"0 */6 * * *": "Every 6 hour",
	"0 1 * * *": "Every 1 day",
	"0 0 */3 * *": "Every 3 day",
	"0 0 * * 0": "Every week",
	"0 0 1 * *": "Every month",
	"0 0 1 1 *": "Every year",
};

export const TOTAL_ORDERS_DATES_TRANSLATION_OPTIONS = {
	"This Week": "thisWeek",
	"This Month": "thisMonth",
	"This Year": "thisYear",
	"All Time": "allTime",
	"Last Week": "lastWeek",
	"Last 2 Weeks": "last2Weeks",
	"Last 30 Days": "last30Days",
	"Last 12 Months": "last12Months",
	"Custom Range": "customRange",
};

export const ORDER_SYNCHRONIZATION_STATUS_TO_TEXT = {
	success: "orderSynchronizedSuccessfully",
	pending_synchronization: "orderIsPendingSynchronization",
	synchronization_failed: "orderSynchronizationFailed",
	status_update_failed: "orderStatusUpdateFailed",
	failed: "orderSynchronizationFailed",
};

export const RATES_SHIPPING_METHODS_TRANSLATIONS = {
	Standard: "standard",
	Priority: "priority",
	Expedited: "expedited",
};

export const ORDER_STATUS_TRANSLATIONS = {
	New: "new",
	Completed: "completed",
	"Partially Completed": "partiallyCompleted",
	"In Progress": "inProgress",
	Canceled: "canceled",
	"Return in progress": "returnInProgress",
	Returned: "returned",
	Error: "error",
};

export const ORDERS_FILTERS = {
	filterByStatus: {
		field: "fulfillments__fulfillment_line_items__status",
		options: [
			{
				id: 1,
				name: "all",
				value: "All",
			},
			{
				id: 2,
				name: "inProgress",
				value: "IN_PROGRESS",
			},
			{
				id: 3,
				name: "partiallyCompleted",
				value: "PARTIALLY_COMPLETED",
			},
			{
				id: 4,
				name: "completed",
				value: "COMPLETED",
			},
			{
				id: 5,
				name: "returnInProgress",
				value: "RETURN_IN_PROGRESS",
			},
			{
				id: 6,
				name: "returned",
				value: "RETURNED",
			},
			{
				id: 7,
				name: "canceled",
				value: "CANCELED",
			},
			{
				id: 8,
				name: "error",
				value: "ERROR",
			},
			{
				id: 9,
				name: "new",
				value: "NEW",
			},
		],
	},
};

export const MY_PRODUCTS_FILTERS = {
	filterByStatus: {
		field: "status",
		options: [
			{
				id: 1,
				name: "public",
				value: "public",
			},
			{
				id: 2,
				name: "inReview",
				value: "in_review",
			},
			{
				id: 3,
				name: "private",
				value: "private",
			},
		],
	},
	filterByAction: {
		field: "action",
		options: [
			{
				id: 1,
				name: "all",
				value: "All",
			},
			{
				id: 2,
				name: "requiresAction",
				value: "Required Action",
			},
		],
	},
};

export const SYSTEM_FILTERS = {
	filterByStatus: {
		field: "status",
		options: [
			{
				id: 1,
				name: "success",
				value: "SUCCESS",
			},
			{
				id: 2,
				name: "pending",
				value: "PENDING",
			},
			{
				id: 3,
				name: "failed",
				value: "FAILED",
			},
		],
	},
};

export const BILLING_PAYPAL_FILTERS = {
	filterByKind: {
		field: "kind",
		options: [
			{
				id: 1,
				name: "payment",
				value: "payment",
			},
			{
				id: 2,
				name: "refund",
				value: "refund",
			},
		],
	},
};

export const SYSTEM_SCHEDULE_STATUS_TO_INFO = {
	SUCCESS: {
		label: "success",
		color: "#117627",
	},
	PENDING: {
		label: "pending",
		color: "#0085FF",
	},
	FAILED: {
		label: "failed",
		color: "#D24023",
	},
};

export const BILLING_FILTERS = {
	filterByStatus: {
		field: "status",
		options: [
			{
				id: 1,
				name: "requiresAction",
				value: "requires_action",
			},
			{
				id: 2,
				name: "succeeded",
				value: "succeeded",
			},
			{
				id: 3,
				name: "requiresPaymentMethod",
				value: "requires_payment_method",
			},
			{
				id: 4,
				name: "requiresConfirmationDefault",
				value: "requires_confirmation",
			},
		],
	},
};

export const BILLING_PAYPAL_KINDS_TRANSLATIONS = {
	Payment: "payment",
	Refund: "refund",
};

export const BILLING_RECEIPTS_STATUS_TRANSLATIONS = {
	requires_action: "requiresAction",
	succeeded: "succeeded",
	requires_payment_method: "requiresPaymentMethod",
	requires_confirmation: "requiresConfirmationDefault",
};

export const ISO_3166_COUNTRY_CODES = [
	"AD",
	"AE",
	"AF",
	"AG",
	"AI",
	"AL",
	"AM",
	"AO",
	"AR",
	"AT",
	"AU",
	"AW",
	"AZ",
	"BA",
	"BB",
	"BD",
	"BE",
	"BF",
	"BG",
	"BH",
	"BI",
	"BJ",
	"BN",
	"BO",
	"BR",
	"BS",
	"BT",
	"BW",
	"BY",
	"BZ",
	"CA",
	"CD",
	"CF",
	"CG",
	"CH",
	"CI",
	"CL",
	"CM",
	"CN",
	"CO",
	"CR",
	"CU",
	"CV",
	"CY",
	"CZ",
	"DE",
	"DJ",
	"DK",
	"DM",
	"DO",
	"DZ",
	"EC",
	"EE",
	"EG",
	"ER",
	"ES",
	"ET",
	"FI",
	"FJ",
	"FM",
	"FR",
	"GA",
	"GB",
	"GD",
	"GE",
	"GH",
	"GM",
	"GN",
	"GQ",
	"GR",
	"GT",
	"GW",
	"GY",
	"HK",
	"HN",
	"HR",
	"HT",
	"HU",
	"ID",
	"IE",
	"IL",
	"IN",
	"IQ",
	"IR",
	"IS",
	"IT",
	"JM",
	"JO",
	"JP",
	"KE",
	"KG",
	"KH",
	"KI",
	"KM",
	"KN",
	"KP",
	"KR",
	"KW",
	"KZ",
	"LA",
	"LB",
	"LC",
	"LI",
	"LK",
	"LR",
	"LS",
	"LT",
	"LU",
	"LV",
	"LY",
	"MA",
	"MC",
	"MD",
	"ME",
	"MG",
	"MH",
	"ML",
	"MM",
	"MN",
	"MR",
	"MT",
	"MU",
	"MV",
	"MW",
	"MX",
	"MY",
	"MZ",
	"NA",
	"NE",
	"NG",
	"NI",
	"NL",
	"NO",
	"NP",
	"NR",
	"NZ",
	"OM",
	"PA",
	"PE",
	"PG",
	"PH",
	"PK",
	"PL",
	"PT",
	"PW",
	"PY",
	"QA",
	"RO",
	"RS",
	"RU",
	"RW",
	"SA",
	"SB",
	"SC",
	"SD",
	"SE",
	"SG",
	"SI",
	"SK",
	"SL",
	"SM",
	"SN",
	"SO",
	"SR",
	"SS",
	"ST",
	"SV",
	"SY",
	"SZ",
	"TD",
	"TG",
	"TH",
	"TJ",
	"TL",
	"TM",
	"TN",
	"TO",
	"TR",
	"TT",
	"TW",
	"TZ",
	"UA",
	"UG",
	"US",
	"UY",
	"UZ",
	"VA",
	"VC",
	"VE",
	"VN",
	"VU",
	"WS",
	"YE",
	"ZA",
	"ZM",
	"ZW",
];

export const GUIDES_LIST = [
	{
		id: 1,
		title: "gettingStartedFromPlatformOverview",
		frame: "https://scribehow.com/embed/Platform_Overview__Ok06UqhnQfirjiLXXpTfdQ?as=video&skipIntro=true",
		search: "Getting Started from Platform Overview. 从平台概述开始。"
	},
	{
		id: 2,
		title: "howToAddNewUsers",
		frame: "https://scribehow.com/embed/Adding_New_Users__D38arUplQbu8OlHX2svpFg?skipIntro=true&as=video",
		search: "How to add New Users? 如何添加新用户？"
	},
	{
		id: 3,
		title: "howToSetupAPaymentMethods",
		frame: "https://scribehow.com/embed/How_To_Setup_A_Payment_Methods__r0yr4q-4QLqLT2ojQpP98w?skipIntro=true&as=video",
		search: "How to Setup a Payment Methods? 如何设置付款方式？"
	},
	{
		id: 4,
		title: "howToUploadProductsManually",
		frame: "https://scribehow.com/embed/How_to_Upload_Products_manually___5h_kb95TEGxKqvjI4yQAw?skipIntro=true&as=video",
		search: "How to Upload Products manually? 如何手动上传产品？"
	},
	{
		id: 5,
		title: "howToLinkYourShopifyStoreAndExportProductsFromCloudOrder",
		frame: "https://scribehow.com/embed/Export_Products_to_Shopify_Store__iTmK3DUCSCaOldNYWMh59g?skipIntro=true&as=video",
		search: "How to link your Shopify store and export products from CloudOrder? 如何链接您的 Shopify 商店并从 CloudOrder 导出产品？"
	},
	{
		id: 6,
		title: "howToOrganizeAndConfigureProductsForVisibilityAndOrderFlow",
		frame: "https://scribehow.com/embed/How_to_organize_and_configure_products_for_visibility_and_order_flow__fQx1Ez-tQEGFUVBk62-HYw?skipIntro=true&as=video",
		search: "How to organize and configure products for visibility and order flow? 如何组织和配置产品以提高能见度和订单流？"
	},
	{
		id: 7,
		title: "howToOrganizeEditAndPrepareProductBeforePublishingThem",
		frame: "https://scribehow.com/embed/How_to_organize_edit_prepare_to_publish_products__Ows7b9qQR6qaM7dMP4Mqpg?skipIntro=true&as=video",
		search: "How to organize, edit, and prepare your products before publishing them? 如何在发布之前组织、编辑和准备您的产品？"
	},
	{
		id: 8,
		title: "howToAddAmazonIntegration",
		frame: "https://scribehow.com/embed/Connect_Amazon_integration__A1ulSUjdT4SaRNkW08j7iA?skipIntro=true&as=video",
		search: "How to add Amazon integration? 如何添加亚马逊集成？"
	},
	{
		id: 9,
		title: "howToEditAndOptimizeMyProducts",
		frame: "https://scribehow.com/embed/How_to_Edit_and_Optimize_my_products__cdzyp_6BRFmc-o6gGsycRQ?skipIntro=true&as=video",
		search: "How to Edit and Optimize my products? 如何编辑和优化我的产品？"
	},
	{
		id: 10,
		title: "howToInstallCloudOrderAppFromShopifyAppStore",
		frame: "https://scribehow.com/embed/Installing_Multi-Channel_Drop_Shipping_App_Guide__fmOb2QaTR0OMQUn8EPadig?skipIntro=true&as=video",
		search: "How to install CloudOrder app from Shopify app store? 如何从 Shopify 应用商店安装 CloudOrder 应用程序？"
	}
]

export const GUIDES_LIST_ZH = [
	{
		id: 1,
		title: "gettingStartedFromPlatformOverview",
		frame: "https://scribehow.com/embed/ZH_or_Platform_Overview__Y50mGlsCTK6uhsOjurgTOg?skipIntro=true&as=video",
		search: "Getting Started from Platform Overview. 从平台概述开始。"
	},
	{
		id: 2,
		title: "howToAddNewUsers",
		frame: "https://scribehow.com/embed/ZH_or_Adding_New_Users__JOtQ5jatRAGN72GyfiuR7Q?skipIntro=true&as=video",
		search: "How to add New Users? 如何添加新用户？"
	},
	{
		id: 3,
		title: "howToSetupAPaymentMethods",
		frame: "https://scribehow.com/embed/ZH_or_How_To_Setup_A_Payment_Methods__KzLXpzcnSO2qsZgTVvH-UQ?skipIntro=true&as=video",
		search: "How to Setup a Payment Methods? 如何设置付款方式？"
	},
	{
		id: 4,
		title: "howToUploadProductsManually",
		frame: "https://scribehow.com/embed/ZH_or_How_to_Upload_Products_manually__HGMuuslySSq1ovl5MsJO-w?skipIntro=true&as=video",
		search: "How to Upload Products manually? 如何手动上传产品？"
	},
	{
		id: 5,
		title: "howToLinkYourShopifyStoreAndExportProductsFromCloudOrder",
		frame: "https://scribehow.com/embed/ZH_or_Export_Products_to_Shopify_From_Dashboard__-fwGN2Z7QSKNaAPWF9QGYA?skipIntro=true&as=video",
		search: "How to link your Shopify store and export products from CloudOrder? 如何链接您的 Shopify 商店并从 CloudOrder 导出产品？"
	},
	{
		id: 6,
		title: "howToOrganizeAndConfigureProductsForVisibilityAndOrderFlow",
		frame: "https://scribehow.com/embed/ZH_or_How_to_organize_and_configure_products_for_visibility_and_order_flow__mM762BrVQE64XxY54Yt0Dg?skipIntro=true&as=video",
		search: "How to organize and configure products for visibility and order flow? 如何组织和配置产品以提高能见度和订单流？"
	},
	{
		id: 7,
		title: "howToOrganizeEditAndPrepareProductBeforePublishingThem",
		frame: "https://scribehow.com/embed/ZH_or_How_to_organize_edit_prepare_to_publish_products__hx9q9bWmTaSPRPdqqxsVig?skipIntro=true&as=video",
		search: "How to organize, edit, and prepare your products before publishing them? 如何在发布之前组织、编辑和准备您的产品？"
	},
	{
		id: 8,
		title: "howToAddAmazonIntegration",
		frame: "https://scribehow.com/embed/ZH_or_Connect_Amazon_integration__WJFD-922SQ-ALk74ImYcPw?skipIntro=true&as=video",
		search: "How to add Amazon integration? 如何添加亚马逊集成？"
	},
	{
		id: 9,
		title: "howToEditAndOptimizeMyProducts",
		frame: "https://scribehow.com/embed/ZH_or_How_to_Edit_and_Optimize_my_products__PqzGXFLPRgOTqc4Tm8a2yA?skipIntro=true&as=video",
		search: "How to Edit and Optimize my products? 如何编辑和优化我的产品？"
	},
	{
		id: 10,
		title: "howToInstallCloudOrderAppFromShopifyAppStore",
		frame: "https://scribehow.com/embed/Installing_Multi-Channel_Drop_Shipping_App_Guide__fmOb2QaTR0OMQUn8EPadig?skipIntro=true&as=video",
		search: "How to install CloudOrder app from Shopify app store? 如何从 Shopify 应用商店安装 CloudOrder 应用程序？"
	}
]